import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';
import { formatDate } from 'app/helpers/formatDate';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { sortCompare } from 'app/helpers/sortCompare';
import { ListBrefLoggurHopurRes } from 'app/interfaces/responses/List/listBrefLoggurHopurRes';

export interface DialogDocumentsKriaOverviewListData {
    data: ListBrefLoggurHopurRes[];
}

@Component({
    selector: 'dialog-documents-kria-overviewList',
    templateUrl: 'dialog-documents-kria-overviewList.html',
    styleUrls: ['dialog-documents-kria-overviewList.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogDocumentsKriaOverviewList extends DialogGeneral {
    @ViewChild('tablePaginator') displayedDataPaginator: MatPaginator;
    documentPageSize: number = 10;
    documentColumns: string[] = [
        'loggnumer',
        'sjodur',
        'dags',
        'breF_HEITI',
        'ktalas',
        'nafns',
        'skjalid',
        'skjalid_hopur',
        'notandi',
        'bref',
        'slod',
    ];
    displayedData: MatTableDataSource<ListBrefLoggurHopurRes> = new MatTableDataSource();

    constructor(
        public matDialogRef: MatDialogRef<DialogDocumentsKriaOverviewList>,
        public dialogRef: MatDialogRef<DialogDocumentsKriaOverviewList>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogDocumentsKriaOverviewListData
    ) {
        super(matDialogRef);
    }

    ngOnInit(): void {
        this.displayedData.data = this.data.data;

        let self = this;
        setTimeout(() => {
            self.displayedData.paginator = self.displayedDataPaginator;
        }, 100);
    }

    formatDate(d) {
        return formatDate(d, false);
    }

    formatKennitala(kt) {
        return formatKennitala(kt);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onNoClickSkipHistory(): void {}

    sortData(sort: Sort) {
        const data = this.displayedData.data.slice();
        if (!sort.active || sort.direction == '') {
            this.displayedData.data = data;
            return;
        }

        this.displayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'loggnumer':
                    return sortCompare(a.loggnumer, b.loggnumer, isAsc);
                case 'sjodur':
                    return sortCompare(a.sjodur, b.sjodur, isAsc);
                case 'dags':
                    return sortCompare(a.dags, b.dags, isAsc);
                case 'breF_HEITI':
                    return sortCompare(a.breF_HEITI, b.breF_HEITI, isAsc);
                case 'ktalas':
                    return sortCompare(a.ktalas, b.ktalas, isAsc);
                case 'nafns':
                    return sortCompare(a.nafns, b.nafns, isAsc);
                case 'skjalid':
                    return sortCompare(a.skjalid, b.skjalid, isAsc);
                case 'skjalid_hopur':
                    return sortCompare(a.skjalid_hopur, b.skjalid_hopur, isAsc);
                case 'notandi':
                    return sortCompare(a.notandi, b.notandi, isAsc);
                case 'bref':
                    return sortCompare(a.bref, b.bref, isAsc);
                case 'slod':
                    return sortCompare(a.slod, b.slod, isAsc);
            }
        });
    }
}
